const isValidPercentage = (percentage) => {
    percentage = Number.parseFloat(percentage);
    return !Number.isNaN(percentage) &&
        percentage >= 0 &&
        percentage <= 100;
};

export default isValidPercentage;